import z from 'zod';

export const MAX_BIO_LENGTH = 200;

export const updateBioInput = z.object({
  bio: z.string().max(MAX_BIO_LENGTH),
});

// Sort keys map to PG columns in the holders query. The legacy `points` key
// is gone (column dropped); legacy `search.*` keys remain via the renamed
// flat columns so the web client doesn't need to know about the change.
export const zSort = z.record(
  z.enum([
    'search.personasCount',
    'search.followersCount',
    'search.followingsCount',
    'firstPersonaAcquiredAt',
  ]),
  z.union([z.literal(1), z.literal(-1)]),
);

export const holdersInput = z.object({
  name: z.string().optional(),
  notFollowed: z.boolean().optional(),
  new: z.boolean().optional(),
  cursor: z.number().min(1).optional().default(1),
  limit: z.number().min(10).max(50).optional().default(25),
  sort: zSort.optional(),
});
